<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 388 512"
			class="icon-file-keynote"
		>
			<path
				opacity=".4"
				class="duotone"
				d="M249.4 0l69.2 69.2 69.2 69.2-110.7 0c-15.3 0-27.7-12.4-27.7-27.7L249.4 0z"
			/>
			<path
				class="duotone"
				d="M.3 27.7C.3 12.4 12.7 0 27.9 0L249.4 0l0 110.7c0 15.3 12.4 27.7 27.7 27.7l110.7 0 0 345.9c0 15.3-12.4 27.7-27.7 27.7L27.9 512C12.7 512 .3 499.6 .3 484.3L.3 27.7zM182.5 335.1c0 7.6 6.2 13.8 13.8 13.8l124.7 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-124.7 0c-7.6 0-13.8 6.2-13.8 13.8zm11.6 54.5c-7.6 0-13.8 6.2-13.8 13.8s6.2 13.8 13.8 13.8l74.8 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-74.8 0zm-55.5-22.4a41.5 41.5 0 1 0 -83 0 41.5 41.5 0 1 0 83 0z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from '../Icon'
export default {
	name: 'KeynoteIcon',
	components: { Icon },
	props,
}
</script>
<style scoped>
svg path {
	fill: #2cb4f2 !important;
}
</style>
